import { getFormFieldChildrenRecursively } from "@/components/DynamicForm/helper/getFormFieldChildrenRecursively";

export const getFlatFormFields = (formConfig) => {
  const formFields = [];
  formConfig?.forEach((formField) => {
    // Push parent level field
    formFields.push(formField);
    // Push children/grandchildren etc
    formFields.push(...getFormFieldChildrenRecursively(formField));
  });
  return formFields;
};
